import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { SelectOption } from '@shared/components/form/form-select/select-option.model';


export enum PaymentType {
    Cash = 1,
    BankCard = 2,
}

export const paymentTypes: SelectOption[] = [
    {
        id: PaymentType.Cash,
        name: marker('data.payment-type.cash'),
    },
    {
        id: PaymentType.BankCard,
        name: marker('data.payment-type.bank-card'),
    },
]
